import React from "react";

export const Marquee = ({ text = "HANDMADE FRESH-BAKED BURGERS", className = "" }) => {
  const chunk = Array.from({ length: 6 }).map((_, i) => (
    <span key={i} className="mx-6 inline-flex items-center gap-6">
      {text}
      <span className="inline-block h-3 w-3 rounded-full bg-brand-ink" />
    </span>
  ));
  return (
    <div className={`overflow-hidden border-y-2 border-brand-ink bg-brand-yellow py-3 ${className}`}>
      <div className="flex w-max animate-marquee whitespace-nowrap font-display text-lg font-bold uppercase tracking-tight text-brand-ink">
        {chunk}
        {chunk}
      </div>
    </div>
  );
};
